<script lang="ts">
	import AdvertisingTemplate from '$lib/components/advertising/AdvertisingTemplate.svelte';
	import { getAdFormatFromDeviceWidth } from '$lib/components/advertising/utils';
	import { adFormatMapping, type AdFormats, getGoogleAdUnit } from '$lib/services/advertising';
	import { onMount } from 'svelte';

	interface Props {
		adFormat: AdFormats;
		adId: string;
		adIdForTests: string;
		adUnit?: string;
		showAdByDefault?: boolean;
		targetings?: Record<string, string>;
		onAdAvailabilityChange?: (isAvailable: boolean) => void;
	}

	const {
		adFormat,
		adId,
		adIdForTests,
		adUnit,
		showAdByDefault = false,
		targetings = {},
		onAdAvailabilityChange,
	}: Props = $props();

	onMount(() => {
		const format = getAdFormatFromDeviceWidth(adFormat);

		if (!format) {
			return;
		}

		let slot: googletag.Slot | undefined;

		// TODO: Remove getGoogleAdUnit once google ads are removed
		const googleAdUnit = adUnit ?? getGoogleAdUnit('en-US', format);
		const size = adFormatMapping[format] as googletag.GeneralSize;

		// Ensure we can interact with the Google Publisher Tag command array.
		window.googletag = window.googletag || { cmd: [] };

		window.googletag.cmd.push(() => {
			slot = googletag.defineSlot(googleAdUnit, size, adId) ?? undefined;

			if (slot) {
				Object.entries(targetings).forEach(([key, value]) => {
					slot?.setTargeting(key, value);
				});

				slot.addService(googletag.pubads());
				googletag.display(slot);

				googletag.pubads().refresh([slot]);
			}
		});

		return () => {
			try {
				if (slot) {
					googletag.destroySlots([slot]);
				}
			} catch (e) {
				console.error('Error destroying google ad slot', e);
			}
		};
	});
</script>

<AdvertisingTemplate {adFormat} {adIdForTests} {adId} {showAdByDefault} {onAdAvailabilityChange} />
